





















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class HdrReportAnalysisTimeTypeSelect extends Vue {
  @Prop()
  private cType: any;
  @Prop()
  private custom: any;
  private get customTime() {
    return this.custom;
  }
  private set customTime(val) {
    this.$emit("customTimeChange", val);
  }
  private changeType(type) {
    this.$emit("change", type);
  }
}
